import { taxTabs } from "./tax-tabs";
import { components } from "./components";
import { newPageNotificationModal } from "./new-page-notification-modal";

export const fiscalData = {
	components,
	taxTabs,
	newPageNotificationModal,
	titlePage: "Tax data",
	titlesTabs: {
		taxCouvert: "Couvert Tax Data",
		taxGroups: "Product Tax Groups",
		taxProfiles: "Tax profiles",
		minimumConsummation: "Minimum consummation",
		recharge: "Recharge",
	},
};
